import React from 'react';
import SEO from './components/SEO';

const pgeoRegistrationFormUrl = "#"; // Placeholder
const pgeoSyllabusUrl = "http://geoolympiad.org/previous.shtml";

export default function PGEOPage() {
  // SEO Data for PGEO page
  const seoData = {
    title: "PGEO",
    description: "Join the Pakistan Geography Olympiad (PGEO) - the official qualifying competition for the International Geography Olympiad (iGeo). Register now for 2025.",
    keywords: "Pakistan Geography Olympiad, PGEO Pakistan, geography competition, International Geography Olympiad, iGeo Pakistan, geography olympiad registration 2025",
    url: "https://capstonepakistan.org/competitions/pgo"
  };

  return (
    <>
      <SEO {...seoData} />
    <div className="min-h-screen bg-white">
      {/* Hero Section - Dynamic Design */}
      <section className="relative py-20 lg:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-green-500" />
        
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-center">
            <img src="/pgeologo.png" alt="PGEO Logo" className="w-32 h-32 object-contain rounded-full mx-auto mb-8 border-4 border-white shadow-2xl bg-black" />
            <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              Pakistan Geography Olympiad
            </h1>
            <h2 className="text-2xl lg:text-3xl font-semibold mb-6 text-white/90">Selection for International Geography Olympiad</h2>
            <p className="text-white/90 leading-relaxed max-w-4xl mx-auto">
              The official National Competition designed to serve as the qualifying stage for the International Geography Olympiad (iGeo) organized by International Geographical Union Olympiad.
            </p>
          </div>
        </div>
      </section>

      {/* About Section - Dynamic Design */}
      <section className="relative py-20 lg:py-32 overflow-hidden bg-white">
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="bg-white rounded-[20px] p-8 lg:p-12 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
            <h2 className="text-3xl lg:text-4xl font-bold text-black mb-6 text-center">About PGEO</h2>
            <div className="space-y-6 text-lg text-black leading-relaxed">
              <p>
                The Pakistan Geography Olympiad is the official National Competition designed to serve as the qualifying stage for the International Geography Olympiad (iGeo) organized by International Geographical Union Olympiad.
              </p>
              <p>
                Following the competition, the top participants will be selected and appointed as members of the Pakistan Geography Team. This team will be representing Pakistan in the iGeo 2024. Participants' performance in the competition will be evaluated for recognition, which may include distinctions such as Honorable Mention, Bronze Medal, Silver Medal, Gold Medal.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Light Background Section - Competition Overview */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Competition Overview
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
              A prestigious geography competition that tests knowledge and understanding of the world
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 text-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Global Knowledge</h3>
              <p className="text-gray-600">Test your understanding of world geography, cultures, and environments</p>
            </div>
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">International Recognition</h3>
              <p className="text-gray-600">Represent Pakistan at the International Geography Olympiad</p>
            </div>
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 text-center">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Academic Excellence</h3>
              <p className="text-gray-600">Demonstrate your geography knowledge and analytical skills</p>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Actions Section - Dynamic Design */}
      <section className="relative py-20 lg:py-32 overflow-hidden bg-white">
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-6xl font-bold text-black mb-6 leading-tight">
              Get Started with PGEO
            </h2>
            <p className="text-xl lg:text-2xl text-black leading-relaxed max-w-3xl mx-auto">
              Everything you need to participate in the Pakistan Geography Olympiad
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-6">
            <a 
              href={pgeoRegistrationFormUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-white rounded-[20px] px-8 py-6 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transform hover:scale-105 transition-all duration-300 text-center"
            >
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
              </div>
              <div className="font-bold text-xl text-gray-900 mb-2">Registration Form</div>
              <div className="text-gray-600">Register for PGEO</div>
            </a>
            <a 
              href={pgeoSyllabusUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-white rounded-[20px] px-8 py-6 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transform hover:scale-105 transition-all duration-300 text-center"
            >
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
                </svg>
              </div>
              <div className="font-bold text-xl text-gray-900 mb-2">Syllabus & Past Problems</div>
              <div className="text-gray-600">Study materials</div>
            </a>

            <a 
              href="https://docs.google.com/forms/d/e/1FAIpQLSc5ehpIcyftzyjp_8YAgPVIzr_f0R4coX91FXhGVqEBtA_6zQ/viewform?usp=sf_link" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-white rounded-[20px] px-8 py-6 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transform hover:scale-105 transition-all duration-300 text-center"
            >
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                </svg>
              </div>
              <div className="font-bold text-xl text-gray-900 mb-2">Campus Ambassador</div>
              <div className="text-gray-600">Join our program</div>
            </a>
          </div>
        </div>
      </section>

      {/* Light Background Section - Competition Details */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Competition Format</h3>
              <div className="space-y-4 text-gray-700">
                <p>Students must register individually. The competition problem will be dispatched to all registered teams participating through schools.</p>
                <p>Each team must submit the solution to their school. The submitted solutions will undergo evaluation by National Organizers.</p>
                <p>Top participants will be selected for the Pakistan Geography Team to take part in the International Geography Olympiad.</p>
              </div>
            </div>
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Eligibility</h3>
              <div className="space-y-4 text-gray-700">
                <p>Students must be enrolled in School Year 8-13/O Levels/A Level/Higher Secondary Education.</p>
                <p>All students who have not yet enrolled in a university are eligible to participate.</p>
                <p>Both individuals and teams can be selected for the Pakistan Geography Team.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Registration & Important Dates Section - Dynamic Design */}
      <section className="relative py-20 lg:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600" />
        
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Registration & Important Dates
            </h2>
            <p className="text-xl lg:text-2xl text-white/90 leading-relaxed max-w-3xl mx-auto">
              Important information about registration and competition timeline
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            {/* Registration Guide */}
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transform hover:scale-105 transition-all duration-300">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Registration Guide</h3>
              </div>
              <div className="space-y-4 text-gray-700">
                <p>Students from each group (consisting of 4 or less students enrolled in the same school) must register for the competition individually or together and enter the name of their group leader.</p>
                <div className="space-y-2">
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3 mt-2"></div>
                    <span><strong>Individual Registration:</strong> Fill out the registration form, enter your own name as group leader, and pay PKR 2,500.</span>
                  </div>
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3 mt-2"></div>
                    <span><strong>Team Registration:</strong> Each member fills the form, all use the same group leader name. Payment can be made individually or collectively (PKR 2,500 per student).</span>
                  </div>
                </div>
                <p className="font-semibold">Confirmation will be sent within 48 hours. Registration deadline: <span className="text-red-600">23rd April 2024</span>.</p>
              </div>
            </div>
            
            {/* Important Dates */}
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400 transform hover:scale-105 transition-all duration-300">
              <div className="text-center mb-6">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Important Dates</h3>
              </div>
              <div className="space-y-3">
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                  <span className="text-gray-700"><strong>Registration Deadline:</strong> 23rd April 2024</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                  <span className="text-gray-700"><strong>Competition Dates:</strong> 20th April 2024 — 27th April 2024</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                  <span className="text-gray-700"><strong>Pakistan Geography Team Announcement:</strong> 29th April 2024</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                  <span className="text-gray-700"><strong>Final Result:</strong> June 2024</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Light Background Section - Rewards & Affiliations */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Rewards & Affiliations
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed max-w-3xl mx-auto">
              Recognition and international partnerships
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Rewards</h3>
              <div className="space-y-4 text-gray-700">
                <p>After the international round, participants will be categorized as:</p>
                <div className="space-y-2">
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                    <span>Successful Participant</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                    <span>Honorable Mention</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                    <span>Bronze Medalist</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                    <span>Silver Medalist</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                    <span>Gold Medalist</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-[20px] p-8 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Affiliations</h3>
              <div className="space-y-2 text-gray-700">
                <p>International Geographical Union</p>
                <p>International Geographical Conference</p>
                <p>Trinity College Dublin</p>
                <p>International Geography Olympiad (iGeo)</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Campus Ambassador Section - Dynamic Design */}
      <section className="relative py-20 lg:py-32 overflow-hidden bg-white">
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-6xl font-bold text-black mb-6 leading-tight">
              Campus Ambassador Program
            </h2>
            <p className="text-xl lg:text-2xl text-black leading-relaxed max-w-3xl mx-auto">
              Join our program and help promote academic excellence in your school!
            </p>
          </div>
          
          <div className="bg-white rounded-[20px] p-8 lg:p-12 shadow-[0_4px_10px_rgba(0,0,0,0.1)] border-r-4 border-b-4 border-teal-400">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">What You'll Do</h3>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-teal-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Promote PGEO and other competitions in your school</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-teal-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Help organize information sessions and workshops</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-teal-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Assist students with registration and preparation</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-teal-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Gain leadership experience and recognition</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-teal-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Receive certificates and potential scholarships</span>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <a 
                  href="https://docs.google.com/forms/d/e/1FAIpQLSc5ehpIcyftzyjp_8YAgPVIzr_f0R4coX91FXhGVqEBtA_6zQ/viewform?usp=sf_link" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="inline-block px-8 py-4 bg-teal-600 hover:bg-teal-700 text-white font-semibold text-lg rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
                >
                  Apply Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section - Dynamic Design */}
      <section className="relative py-20 lg:py-32 overflow-hidden bg-white">
        <div className="relative max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-6xl font-bold text-black mb-6 leading-tight">
            Get in Touch
          </h2>
          <p className="text-xl lg:text-2xl text-black leading-relaxed max-w-3xl mx-auto mb-12">
            Have questions? We're here to help you succeed in PGEO 2024
          </p>
          <a 
            href="mailto:admin@capstonepakistan.org" 
            className="inline-block px-8 py-4 bg-white hover:bg-gray-100 text-black font-semibold text-lg rounded-lg border-2 border-gray-900 transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
          >
            Contact Us
          </a>
        </div>
      </section>
    </div>
    </>
  );
} 